import { render, staticRenderFns } from "./LinkPhonenumber.vue?vue&type=template&id=4c281c1e&scoped=true&"
import script from "./LinkPhonenumber.vue?vue&type=script&lang=js&"
export * from "./LinkPhonenumber.vue?vue&type=script&lang=js&"
import style0 from "./LinkPhonenumber.vue?vue&type=style&index=0&id=4c281c1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c281c1e",
  null
  
)

export default component.exports